
































import { Component, Vue } from 'vue-property-decorator'

import { alert } from '@/store/modules/alert'

@Component
class NotificationBar extends Vue {
  alert = alert.context(this.$store)
}

export default NotificationBar
